import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OverAskMessagesProvider } from '../../../services/over-ask-messages.provider';

@Component({
    selector: 'bs-digital-over-ask-summary-errors',
    templateUrl: './betslip-over-ask-summary-errors.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskSummaryErrorsComponent {
    readonly messages: {
        summaryOfferChanges: string;
    };

    constructor(overAskMessagesProvider: OverAskMessagesProvider) {
        this.messages = {
            summaryOfferChanges: overAskMessagesProvider.messages.summaryOfferChanges,
        };
    }
}
